export default __webpack_public_path__ + "static/media/snapchat-square-brands.ecc24704.svg";